module.exports = __webpack_public_path__ + "img/chevron-right.4ebebb99.svg";